import { render, staticRenderFns } from "./ClaimsIntro.vue?vue&type=template&id=7984ab7f&scoped=true"
import script from "./ClaimsIntro.vue?vue&type=script&lang=js"
export * from "./ClaimsIntro.vue?vue&type=script&lang=js"
import style0 from "./ClaimsIntro.vue?vue&type=style&index=0&id=7984ab7f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7984ab7f",
  null
  
)

export default component.exports